import React from 'react';
import { RadioProps } from '~/components/Radio/Radio';
import styles from './radio-group.module.scss';

type RadioGroupOrientation = 'horizontal' | 'vertical';

type RadioGroupProps = React.HTMLAttributes<HTMLDivElement> & {
  /**
   * RadioGroup name
   */
  name: string;
  /**
   * RadioGroup current checked value
   */
  value?: number | string;
  /**
   * RadioGroup orientation, 'horizontal' by default
   */
  orientation?: RadioGroupOrientation;
  /**
   * Callback used when the checked state changes
   */
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};
export const RadioGroup = (props: RadioGroupProps) => {
  const { name, value, orientation = 'horizontal', onChange, children } = props;

  return (
    <div className={[styles.root, styles[orientation]].join(' ')}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) {
          return null;
        }

        return React.cloneElement(child as React.ReactElement<RadioProps>, {
          checked: child.props.value === value,
          onChange: onChange,
        });
      })}
    </div>
  );
};
